import React from "react";
import "./Manual.css";
function Manual() {
  return (
    <div className="plant-info-manual">
      {/* Section 1: Plant Species Identification */}
      <section className="plant-identification-manual">
        <h2 className="title-manual">Plant Species Identification</h2>
        <p className="description-manual">
          Learn how to identify plant species in the Sundarbans by uploading a
          photo using the Sundori app. This feature allows users to instantly
          receive information about the plant species from their uploaded image.
        </p>
        <ol className="steps-manual">
          <li>Go to the Plant Identification page.</li>
          <li>Upload the image/photo of the plant you want to identify.</li>
          <li>
            Check the Detected Plant section to see if it has been identified.
          </li>
          <li>Click on the plant name to go to the Plant Details page.</li>
        </ol>

        <img className="manual-img" alt="poit" src="Assets/Manual/1.png"></img>
      </section>

      {/* Section 2: Viewing Recent Identifications */}
      <section className="recent-identifications-manual">
        <h2 className="title-manual">Recent Identifications</h2>
        <p className="description-manual">
          This feature allows users to browse the latest plant identifications
          made by others. It’s a great way to explore what other users have
          discovered in the Sundarbans.
        </p>
        <ol className="steps-manual">
          <li>Go to the Plant Identification page.</li>
          <li>Scroll down to the Recent Identified Species section.</li>
          <li>Browse through the list of recently identified plants.</li>
          <li>
            Click on any plant to explore detailed information about that
            species.
          </li>
        </ol>
      </section>

      {/* Section 3: Accessing Species Details */}
      <section className="species-details-manual">
        <h2 className="title-manual">Species Details</h2>
        <p className="description-manual">
          Discover detailed information about various plant species in the
          Sundarbans. This section provides users with in-depth knowledge,
          including scientific names, characteristics, and habitats.
        </p>
        <ol className="steps-manual">
          <li>
            Navigate to a species details page from one of the following
            sections:
          </li>
          <ul>
            <li>Species List page</li>
            <li>Plant Identification section</li>
            <li>Recently Identified Species section</li>
          </ul>
          <li>Click on any species to explore detailed information.</li>
        </ol>
      </section>
    </div>
  );
}

export default Manual;
